import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export default class Nav {
    constructor() {

        this.init();
        this.startX = 0;
        this.startY = 0;

    }

    init() {

        this.navHeight();

        this.initShowHideNav();

        this.initNavSearch();
        this.initNavCart();
        this.initNavBurger();

        this.initResponsiveSubMenus()
        this.initHoverSubMenus();

        this.initSwipeListeners();

        this.attachAnchorListeners();
        this.scrollToAnchorOnLoad();

        window.removeEventListener("resize", this.handleResize);
        window.addEventListener("resize", this.handleResize.bind(this));
    }

    handleResize() {
        this.initResponsiveSubMenus();
        this.initHoverSubMenus();
    }

    // === NAVHEIGHT ===
    navHeight() {
        const navElement = document.querySelector('.nav-sticky');
        if (navElement) {
            const navHeight = navElement.offsetHeight;
            document.documentElement.style.setProperty('--nav-height', `${navHeight}px`);
        }
    }

    // === SHOW/HIDE NAV ===
    initShowHideNav() {
        const navSticky = document.querySelector('.nav-sticky');

        if (navSticky) {
            const showhideNav = gsap.from(navSticky, {
                opacity: 0,
                paused: true,
                duration: 0.5,
            }).progress(1);

            ScrollTrigger.create({
                start: 'top top',
                end: 99999,
                onUpdate: (self) => {
                    if (self.direction === -1) {
                        showhideNav.play();
                        navSticky.classList.add('has-bg');
                    } else {
                        showhideNav.reverse();
                        navSticky.classList.add('has-scrolled');
                    }

                    const minScrollTop = document.body.classList.contains('admin-bar') ? 32 : 0;
                    if (window.scrollY <= minScrollTop) {
                        navSticky.classList.remove('has-scrolled', 'has-bg');
                    }
                },
            });
        }
    }

    // === NAV SEARCH ===
    initNavSearch() {
        document.querySelectorAll(".nav-search").forEach(item => {
            item.addEventListener("click", () => {
                document.querySelector(".nav-search-modal").classList.toggle("active");
                document.documentElement.classList.toggle("block-viewport");
                document.body.classList.toggle("block-viewport");
            });
        });
        document.querySelectorAll(".nav-search-modal .search-close").forEach(item => {
            item.addEventListener("click", () => {
                document.querySelector(".nav-search-modal").classList.toggle("active");
                document.documentElement.classList.toggle("block-viewport");
                document.body.classList.toggle("block-viewport");
            });
        });
    }

    // === NAV CART ===
    initNavCart() {
        document.querySelectorAll(".nav-cart").forEach(item => {
            item.addEventListener("click", () => this.toggleCart());
        });
        document.querySelectorAll(".nav-cart-modal .cart-close, .nav-cart-overlay").forEach(item => {
            item.addEventListener("click", () => this.toggleCart());
        });
    }

    // === TOGGLE NAV CART / NAV CART OVERLAY / NAV RESPONSIVE
    toggleCart() {
        const navCartModal = document.querySelector(".nav-cart-modal");
        const navCartOverlay = document.querySelector(".nav-cart-overlay");
        const navResponsive = document.querySelector(".nav-responsive");
        const isCartModalActive = navCartModal.classList.contains("active");
        navCartModal.classList.toggle("active");
        navCartOverlay.classList.toggle("active");
        if (!isCartModalActive) {
            navResponsive.classList.remove("active");
            document.querySelector(".nav-burger").classList.remove("active");
            document.documentElement.classList.add("block-viewport");
            document.body.classList.add("block-viewport");
        } else {
            if (!document.querySelector(".nav-search-modal.active")) {
                document.documentElement.classList.remove("block-viewport");
                document.body.classList.remove("block-viewport");
            }
        }
    }

    // === NAV BURGER ===
    initNavBurger() {
        const navBurgers = document.querySelectorAll(".nav-burger");
        const navResponsive = document.querySelector(".nav-responsive");
        const navOverlay = document.querySelector(".nav-responsive-overlay");

        if (!navBurgers.length || !navResponsive) return;

        navBurgers.forEach(burger => {
            burger.addEventListener("click", () => {
                navBurgers.forEach(b => b.classList.toggle("active"));

                navResponsive.classList.toggle("active");
                if (navOverlay) navOverlay.classList.toggle("active");

                document.documentElement.classList.toggle("block-viewport");
                document.body.classList.toggle("block-viewport");
            });
        });
    }


    // === SWIPE NAV LISTENER ===
    initSwipeListeners() {
        const navResponsive = document.querySelector('.nav-responsive');
        const navCartModal = document.querySelector('.nav-cart-modal');
        if (navResponsive) {
            navResponsive.addEventListener('touchstart', (e) => this.handleTouchStart(e), false);
            navResponsive.addEventListener('touchmove', (e) => this.handleTouchMove(e, 'responsive'), false);
        }
        if (navCartModal) {
            navCartModal.addEventListener('touchstart', (e) => this.handleTouchStart(e), false);
            navCartModal.addEventListener('touchmove', (e) => this.handleTouchMove(e, 'cart'), false);
        }
    }

    handleTouchStart(e) {
        const firstTouch = e.touches[0];
        this.startX = firstTouch.clientX;
        this.startY = firstTouch.clientY;
    }

    handleTouchMove(e, type) {
        if (!this.startX || !this.startY) {
            return;
        }
        const moveEndX = e.touches[0].clientX;
        const moveEndY = e.touches[0].clientY;
        const diffX = this.startX - moveEndX;
        const diffY = this.startY - moveEndY;
        if (Math.abs(diffX) > Math.abs(diffY)) {
            if (diffX > 0 && type === 'responsive') {
                this.closeNavResponsive();
            } else if (diffX < 0 && type === 'cart') {
                this.toggleCart(false);
            }
        }
        this.startX = 0;
        this.startY = 0;
    }

    // === CLOSE NAV REPSONSIVE ===
    closeNavResponsive() {
        document.querySelector('.nav-responsive').classList.remove('active');
        document.querySelector('.nav-burger').classList.remove('active');
        this.manageViewportBlock(false);
    }

    // === BLOCKVIEWPORT ===
    manageViewportBlock(shouldBlock) {
        if (shouldBlock) {
            document.documentElement.classList.add("block-viewport");
            document.body.classList.add("block-viewport");
        } else {
            if (!document.querySelector('.nav-cart-modal.active') && !document.querySelector('.nav-search-modal.active')) {
                document.documentElement.classList.remove("block-viewport");
                document.body.classList.remove("block-viewport");
            }
        }
    }

    // === HREF HAVE ANCHOR ===
    attachAnchorListeners() {
        document.querySelectorAll('li.menu-item a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function(e) {
                e.preventDefault();
                const targetId = this.getAttribute('href');
                if (targetId === '#' || !document.querySelector(targetId)) {
                    console.log("Ancre non valide ou ignorée : " + targetId);
                    return;
                }
                const targetElement = document.querySelector(targetId);
                if(targetElement) {
                    gsap.to(window, {
                        scrollTo: {
                            y: targetElement,
                            autoKill: false
                        },
                        duration: 1
                    });
                }
            });
        });
    }

    // === SCROLL TO ANCHOR ===
    scrollToAnchorOnLoad() {
        const hash = window.location.hash;
        if (hash) {
            const targetElement = document.querySelector(hash);
            if (targetElement) {
                gsap.to(window, {
                    scrollTo: {
                        y: targetElement,
                        autoKill: false
                    },
                    duration: 1,
                    delay: 0.25
                });
            }
        }
    }

    // === HOVER SUB MENUS ===
    initHoverSubMenus() {
        const menuItems = document.querySelectorAll(".menu-item-has-children");

        let maxSubMenuHeight = 0;

        document.querySelectorAll("nav .megamenu, nav .sub-menu").forEach(menu => {
            const originalVisibility = menu.style.visibility;
            const originalPosition = menu.style.position;
            const originalDisplay = menu.style.display;

            menu.style.visibility = "hidden";
            menu.style.position = "absolute";
            menu.style.display = "block";

            const menuHeight = menu.scrollHeight;

            menu.style.visibility = originalVisibility;
            menu.style.position = originalPosition;
            menu.style.display = originalDisplay;

            if (menuHeight > maxSubMenuHeight) {
                maxSubMenuHeight = menuHeight;
            }
        });

        document.documentElement.style.setProperty("--max-submenu-height", `${maxSubMenuHeight}px`);

        menuItems.forEach((item) => {
            let timeout;
            const megamenu = item.querySelector(":scope > .megamenu");
            const subMenus = item.querySelectorAll(":scope > .sub-menu");

            item.addEventListener("mouseenter", () => {
                clearTimeout(timeout);
                item.classList.add("hover-active");
            });

            item.addEventListener("mouseleave", () => {
                timeout = setTimeout(() => {
                    item.classList.remove("hover-active");
                }, 300);
            });

            subMenus.forEach((subMenu) => {
                subMenu.addEventListener("mouseenter", () => {
                    clearTimeout(timeout);
                    item.classList.add("hover-active");
                });

                subMenu.addEventListener("mouseleave", () => {
                    timeout = setTimeout(() => {
                        item.classList.remove("hover-active");
                    }, 300);
                });
            });
        });
    }

    // === RESPONSIVE SUB MENU ===
    // initResponsiveSubMenus() {
    //     document.querySelectorAll(".nav-responsive ul.menu > li.menu-item-has-children > a").forEach(function(link) {
    //         link.addEventListener("click", function(e) {
    //             e.preventDefault();
    //             const parentLi = this.closest("li.menu-item-has-children");
    //             const subMenu = parentLi.querySelector("ul.sub-menu");
    //             const isActive = parentLi.classList.contains("active");
    //
    //             document.querySelectorAll(".nav-responsive ul.menu li.menu-item-has-children").forEach(function(item) {
    //                 if (item !== parentLi) {
    //                     item.classList.remove("active");
    //
    //                     const otherSubMenu = item.querySelector("ul.sub-menu");
    //                     if( otherSubMenu ) {
    //                         gsap.to(otherSubMenu, {
    //                             height: 0,
    //                             opacity: 0,
    //                             duration: .5,
    //                             ease: "power2.inOut",
    //                             onComplete: () => {
    //                                 otherSubMenu.style.display = "none";
    //                             }
    //                         });
    //                     }
    //                 }
    //             });
    //             if (!isActive) {
    //                 parentLi.classList.add("active");
    //
    //                 subMenu.style.display = "flex";
    //                 const subMenuHeight = subMenu.scrollHeight;
    //
    //                 gsap.fromTo(subMenu, {
    //                     height: 0,
    //                     opacity: 0
    //                 }, {
    //                     height: subMenuHeight,
    //                     opacity: 1,
    //                     duration: .5,
    //                     ease: "power2.inOut",
    //                     clearProps: 'height'
    //                 });
    //             } else {
    //                 parentLi.classList.remove("active");
    //                 gsap.to(subMenu, {
    //                     height: 0,
    //                     opacity: 0,
    //                     duration: .5,
    //                     ease: "power2.inOut",
    //                     onComplete: () => {
    //                         subMenu.style.display = "none";
    //                     }
    //                 });
    //             }
    //         });
    //     });
    // }

    // === RESPONSIVE SUB MENU WITH PANELS ===

    initResponsiveSubMenus() {
        if (window.innerWidth >= 1400) return;

        const menuContainer = document.querySelector(".nav-responsive ul.menu");
        if (!menuContainer) return;

        document.querySelectorAll(".nav-responsive ul.menu > li.menu-item-has-children > a").forEach(link => {
            link.addEventListener("click", function (e) {
                e.preventDefault();
                const parentLi = this.closest("li.menu-item-has-children");
                const megaMenu = parentLi.querySelector(".megamenu");
                if (!megaMenu) return;

                if (!megaMenu.querySelector(".submenu-back")) {
                    const backButton = document.createElement("button");
                    backButton.classList.add("submenu-back");
                    backButton.innerHTML = "← Retour";
                    backButton.addEventListener("click", function (e) {
                        e.preventDefault();
                        gsap.to(megaMenu, {
                            x: "100%",
                            opacity: 0,
                            duration: 0.5,
                            ease: "power2.inOut",
                            onComplete: () => {
                                megaMenu.classList.remove("active");
                            }
                        });
                    });
                    megaMenu.prepend(backButton);
                }

                megaMenu.classList.add("active");
                gsap.fromTo(megaMenu,
                    { x: "100%", opacity: 0 },
                    { x: "0%", opacity: 1, duration: 0.5, ease: "power2.inOut" }
                );
            });
        });

        document.querySelectorAll(".megamenu .sub-menu.level-0 > li.menu-item-has-children > a").forEach(link => {
            link.addEventListener("click", function (e) {
                e.preventDefault();
                const parentLi = this.closest("li.menu-item-has-children");
                const subMenuLevel1 = parentLi.querySelector(".sub-menu.level-1");
                if (!subMenuLevel1) return;

                if (!subMenuLevel1.querySelector(".submenu-back")) {
                    const backButton = document.createElement("button");
                    backButton.classList.add("submenu-back");
                    backButton.innerHTML = "← Retour";
                    backButton.addEventListener("click", function (e) {
                        e.preventDefault();
                        gsap.to(subMenuLevel1, {
                            x: "100%",
                            opacity: 0,
                            duration: 0.5,
                            ease: "power2.inOut",
                            onComplete: () => {
                                subMenuLevel1.classList.remove("active");
                            }
                        });
                    });
                    subMenuLevel1.prepend(backButton);
                }

                subMenuLevel1.classList.add("active");
                gsap.fromTo(subMenuLevel1,
                    { x: "100%", opacity: 0 },
                    { x: "0%", opacity: 1, duration: 0.5, ease: "power2.inOut" }
                );
            });
        });
    }


}